module.exports = __webpack_public_path__ + "static/media/Vanuatu_Logo.1e9d67fd.png";